import TableBase from 'components/Table/TableBase'
import { numberWithCommas } from 'utils'
import { Link } from 'react-router-dom'

const HistoryTable = ({ data, setParams, params }) => {
  const columns = [
    {
      title: 'Tài khoản',
      dataIndex: 'customer_id',
      render: (value) => value,
      align: 'left',
      width: 100,
    },
    {
      title: 'Nguồn quỹ',
      dataIndex: 'fund_source',
      align: 'left',
      render: (value) => value,
      width: 120,
    },
    {
      title: 'Số tiền',
      render: (record) => (
        <div>
          {record?.amount >= 0 && (
            <div className="text-right text-green text-bold">{numberWithCommas(record?.amount)}</div>
          )}
          {record?.amount < 0 && (
            <div className="text-right text-red text-bold">{numberWithCommas(record?.amount)}</div>
          )}
        </div>
      ),
      minWidth: 120,

    },
    {
      title: 'Tài khoản',
      render: (record) => (
        <div>
          {record?.action == 3 && (
            <div className='text-left' dangerouslySetInnerHTML={{ __html: record?.account }} />
          )}
          {record?.action != 3 && (
            <div className="text-left">{record?.customer_id}</div>
          )}
        </div>
      ),
      width: 220,
    },
    {
      title: 'Quỹ hiện tại',
      render: (record) => (
        <div>
          {record?.balance_after >= 0 && (
            <div className="text-right text-green text-bold">{numberWithCommas(record?.balance_after)}</div>
          )}
          {record?.balance_after < 0 && (
            <div className="text-right text-red text-bold">{numberWithCommas(record?.balance_after)}</div>
          )}
        </div>
      ),
      width: 110,
    },
    {
      title: 'Nội dung',
      dataIndex: 'note',
      render: (value) => (
        <div className="text-right" dangerouslySetInnerHTML={{ __html: value }} />
      ),
    },
    {
      title: 'Thời gian',
      dataIndex: 'created_at',
      render: (value) => value,
      width: 150,
    },
    {
      title: 'Thao tác',
      render: (record) => (
        <div>
          {record?.reconcilation_id && (
            <Link to={`/bao-cao-tai-chinh?reconcilation_id=${record?.reconcilation_id}`}>Chi tiết</Link>
          )}
        </div>
      ),
      width: 90,

    },
  ]

  return (

    <TableBase
      columns={columns}
      style={{ minHeight: '300px' }}
      dataSource={data?.escrowHistories}
      pagination={{
        current: data?.meta?.current_page,
        pageSize: data?.meta?.per_page,
        total: data?.meta?.total,
        showSizeChanger: true,
        onChange: (page, pageSize) => {
          if (pageSize !== data?.meta?.per_page) {
            page = 1
          }
          window.scrollTo({ top: 0, behavior: 'smooth' })
          setParams((prev) => ({
            ...prev,
            page: page,
            per_page: pageSize,
          }))
        },
        showTotal: (total) => `Tổng ${total}`,
      }}
      scroll={{ x: 1000 }}
      rowKey={(row) => row?.id}
    />
  )
}

export default HistoryTable
